<template>
  <div>
    <p v-if="!day.entry && !addNewEntry">
      You haven't logged any entries for this day yet. Please click the button
      below to get started.
    </p>

    <a
      v-if="!addNewEntry"
      class="add-entry button button--standard"
      href="#"
      @click.prevent="addNewEntry = true"
      >Add new blood pressure entry</a
    >

    <form @submit.prevent="submitForm" v-if="addNewEntry">
      <div class="field">
        <label for="pacing-time">
          <span>Time</span>
          <input
            type="time"
            id="pacing-time"
            v-model="form.time"
            required
            @invalid="invalidTime"
          />
        </label>
      </div>

      <div class="field">
        <label for="systolic">
          <span>Systolic Blood Pressure</span>
          <input type="text" id="systolic" v-model="form.systolic" required />
        </label>
      </div>

      <div class="field">
        <label for="diastolic">
          <span>Diastolic Blood Pressure</span>
          <input type="text" id="diastolic" v-model="form.diastolic" required />
        </label>
      </div>

      <button type="submit" class="button button--standard">
        Log your blood pressure
      </button>
      <button
        class="button button--danger"
        @click.prevent="addNewEntry = false"
      >
        Cancel
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: "Form",

  props: ["day", "existingEntry"],

  data() {
    return {
      addNewEntry: false,
      form: {
        time: "",
        diastolic: "",
        systolic: "",
      },
    };
  },

  methods: {
    submitForm() {
      this.addNewEntry = false;

      // Emit event to the parent to send data to Firebase.
      this.$emit("form-submit", this.form, this.day);

      // Clear form values.
      this.form = {};
    },

    invalidTime({ target }) {
      target.setCustomValidity("Please enter a valid time.");
    },
  },
};
</script>

<style scoped>
button {
  margin-right: 1rem;
}
p {
  margin-top: 0;
}
</style>
